export default __webpack_public_path__ + "static/media/MOTO_SEGURA_330x330.49994e56.png";